<template>
  <v-tooltip 
    v-model="show" 
    right
    :open-on-hover="$vuetify.breakpoint.mdAndUp"
    open-on-click
  >
    <template #activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on" @click.stop="toggleTooltip">
        <slot />
      </span>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    tooltipText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: false,
    };
  },
  created() {
    // Listen for the custom event to close other tooltips
    this.$root.$on('close-other-tooltips', (currentId) => {
      if (this._uid !== currentId) {
        this.show = false;
      }
    });
  },
  beforeDestroy() {
    // Clean up event listener
    this.$root.$off('close-other-tooltips');
  },
  methods: {
    toggleTooltip() {
      if (this.$vuetify.breakpoint.smAndDown) {
        // If opening the tooltip, close all others first
        if (!this.show) {
          this.$root.$emit('close-other-tooltips', this._uid);
        }
        this.show = !this.show;
      }
    }
  }
};
</script>
